import React from 'react'

import theme from 'theme'

const Dot = React.forwardRef<
  HTMLDivElement,
  {
    color?: string
  }
>(({ color = theme.colors.steel[0], ...rest }, ref) => (
  <div
    ref={ref}
    css={{
      backgroundColor: color,
      borderRadius: '100%',
      height: '0.75rem',
      width: '0.75rem',
      zIndex: 0,
      flex: 'none'
    }}
    {...rest}
  />
))

Dot.displayName = 'Dot'

export default Dot
